<script setup>
import moment from "moment";
import listStatus from "@/data/statusIMKP.json";
import { levelEnum, statusIMKPEnum } from "@/utilities/enum";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12" v-if="cocCheckPending" class="text-center py-10">
        <p class="font-medium text-lg text-slate-500">
          Memverifikasi data CoC…
        </p>
      </v-col>
      <v-col cols="12" v-else-if="haveCoC">
        <div class="flex justify-between items-end">
          <div>
            <h2 class="text-red-600 text-3xl font-inter font-bold">
              IMKP (Izin Melaksanakan Kegiatan Proyek)
            </h2>
            <p class="text-gray-500">
              Sini-Saja membantu mengelola & memantau perkembangan kegiatan
              kontraktor
            </p>
          </div>
          <div class="flex justify-end flex-wrap gap-2">
            <v-btn
              class="bg-red-600 text-white capitalize"
              v-if="userData.role === levelEnum.KONTRAKTOR && !isBlockReqImkp"
              @click="dialogRequestImkp = true"
            >
              <font-awesome-icon
                icon="fa-solid fa-file-circle-plus"
                class="mr-2"
                style="color: #eeecec"
              />
              Request Pengajuan IMKP
            </v-btn>
            <button
              class="btn btn-danger"
              v-else-if="
                userData.role === levelEnum.KONTRAKTOR && isBlockReqImkp
              "
            >
              <font-awesome-icon
                icon="fa-solid fa-circle-minus"
                style="color: #eeecec"
              />
              Anda tidak dapat melakukan pengajuan IMKP. <br />
              Silahkan lakukan BAST telebih dahulu pada IMKP yang telah lewat
              tanggal selesai pekerjaannya.
            </button>
          </div>
        </div>
        <v-row class="mt-5">
          <v-col cols="6">
            <table
              class="table w-100 rounded table-borderless"
              style="overflow: hidden; font-family: 'Inter-Regular', serif"
            >
              <thead class="font-inter text-[#28293d] font-normal">
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2 text-nowrap text-sm" style="width: 30%">
                    Status
                  </th>
                  <th class="p-2 text-nowrap text-sm" style="width: 70%">
                    Keterangan
                  </th>
                </tr>
              </thead>
              <tbody class="text-xs">
                <tr
                  v-for="(data, index) in listStatus.filter((status) =>
                    status.role.some((level) => level === levelEnum.KONTRAKTOR),
                  )"
                  :key="index"
                >
                  <td
                    class="align-items-center"
                    :class="{ 'table-secondary': index % 2 == 1 }"
                  >
                    <span
                      class="p-1 rounded-md text-white mx-auto"
                      :style="`background-color: ${data.color};`"
                    >
                      {{ data.name }}
                    </span>
                  </td>
                  <td :class="{ 'table-secondary': index % 2 == 1 }">
                    {{ data.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="12">
            <v-row class="bg-white rounded-lg p-3 shadow-md mt-5">
              <v-col cols="4">
                <v-text-field
                  variant="outlined"
                  density="compact"
                  color="red"
                  hide-details
                  clearable
                  v-model="paramsImkp.keyword"
                  v-on:keyup.enter="fetchData"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Masukkan judul proyek"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn
                  class="bg-red-600 w-full text-white capitalize"
                  @click="fetchData"
                >
                  Cari Data
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <div class="my-8 rounded-lg shadow-md overflow-x-auto w-full">
            <v-data-table-server
              v-model:items-per-page="dataTable.pagination.itemsPerPage"
              :items-per-page-options="[5, 10, 25, 50, 100]"
              :headers="dataTable.headers"
              :items="dataTable.items"
              :items-length="dataTable.pagination.totalItems"
              @update:options="fetchData"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  class="border-b border-gray-950 h-16"
                  :class="{
                    'bg-gray-50': index % 2 !== 0,
                  }"
                >
                  <td class="text-wrap">
                    {{ item.judulProyek }}
                    <span
                      class="py-1 px-2 me-3 badge rounded text-sm-center text-black bg-info-subtle"
                      v-if="item.status !== statusIMKPEnum.DRAFT"
                    >
                      Revisi ke- {{ item.revisi }}
                    </span>
                    <span
                      class="py-1 px-2 me-3 badge rounded text-sm-center text-black bg-primary-subtle"
                      v-if="
                        item.status !== statusIMKPEnum.DRAFT &&
                        item.amandemen !== 0
                      "
                    >
                      Amandemen ke- {{ item.amandemen }}
                    </span>
                    <span
                      class="py-1 px-2 badge rounded text-sm-center text-black bg-warning cursor-pointer"
                      v-if="
                        item.status !== statusIMKPEnum.DRAFT &&
                        item.amandemen !== 0
                      "
                      @click="openHistory(item.id)"
                    >
                      Lihat history
                    </span>

                    <div
                      v-if="
                        item.isFinished &&
                        item.status !== statusIMKPEnum.BAST_PROCESS &&
                        item.status !== statusIMKPEnum.IMKP_DONE
                      "
                    >
                      <p class="fs-8 m-0 text-danger fw-semibold fst-italic">
                        <span class="fs-7">*</span>
                        Mohon lakukan BAST pada proyek ini
                      </p>
                    </div>
                    <div
                      v-if="item.isObsolete"
                      class="d-flex align-items-center gap-2"
                    >
                      <ul class="fs-8 m-0 text-danger fw-semibold opacity-100">
                        <li
                          v-for="(item, i) in normalizeList(item.alasanTolak)"
                          :key="i"
                        >
                          {{ item }}
                        </li>
                      </ul>
                      <a
                        class="text-danger fw-bolder cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        :title="'Lihat Detail'"
                        style="text-decoration: none"
                        @click="redirectToLink('/imkp/', item.id)"
                      >
                        <img
                          :src="require('@/assets/icons/lihat_dokumen_sio.png')"
                          alt=""
                          class="h-auto"
                          :style="'width: 1.5rem;'"
                        />
                      </a>
                    </div>
                  </td>
                  <td
                    class="text-nowrap text-center"
                    :class="{ 'opacity-50': item.isObsolete }"
                  >
                    {{
                      item.tanggalMulaiPekerjaan
                        ? moment(new Date(item.tanggalMulaiPekerjaan)).format(
                            "DD MMM YYYY",
                          )
                        : null
                    }}
                  </td>
                  <td
                    class="text-nowrap text-center"
                    :class="{ 'opacity-50': item.isObsolete }"
                  >
                    {{
                      item.tanggalSelesaiPekerjaan
                        ? moment(new Date(item.tanggalSelesaiPekerjaan)).format(
                            "DD MMM YYYY",
                          )
                        : null
                    }}
                  </td>
                  <td
                    class="text-center"
                    :class="{ 'opacity-50': item.isObsolete }"
                  >
                    <div
                      v-if="
                        listStatus.some((data) => data.status === item.status)
                      "
                    >
                      <span
                        v-for="data in listStatus.filter(
                          (data) => data.status === item.status,
                        )"
                        :key="data.id"
                        class="badge"
                        style="color: #f2f0f0"
                        :style="{ 'background-color': data.color }"
                      >
                        {{ data.name }}
                      </span>
                    </div>
                  </td>
                  <td
                    class="text-center flex justify-between items-center border-b-0 w-full"
                  >
                    <a
                      class="text-red-600 font-bold text-center mr-2"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      :title="!item.isObsolete ? 'Lihat Dokumen' : ''"
                      style="text-decoration: none"
                      @click="
                        !item.isObsolete
                          ? redirectToLink('/imkp/', item.id)
                          : ''
                      "
                      :class="{
                        'opacity-50': item.isObsolete,
                      }"
                    >
                      <img
                        :src="
                          item.isObsolete
                            ? require('@/assets/icons/close-64.png')
                            : item.status === statusIMKPEnum.DRAFT ||
                              item.status === statusIMKPEnum.UNDER_REVIEW ||
                              item.status === statusIMKPEnum.NEED_REVISION
                            ? require('@/assets/icons/isi_penilaian_sio.png')
                            : require('@/assets/icons/lihat_dokumen_sio.png')
                        "
                        alt=""
                        class="h-auto cursor-pointer"
                        :style="
                          item.isObsolete
                            ? 'width: 4rem'
                            : item.status === statusIMKPEnum.DRAFT ||
                              item.status === statusIMKPEnum.UNDER_REVIEW ||
                              item.status === statusIMKPEnum.NEED_REVISION
                            ? 'width: 1.4rem;'
                            : 'width: 2rem;'
                        "
                      />
                    </a>
                    <a
                      class="text-danger fw-bolder cursor-pointer"
                      :class="{
                        'opacity-50':
                          item.status !== statusIMKPEnum.IMKP_PUBLISHED &&
                          item.status !== statusIMKPEnum.BAST_PROCESS &&
                          item.status !== statusIMKPEnum.BAST_REVISION &&
                          item.status !== statusIMKPEnum.BAST_WARRANTY &&
                          item.status !==
                            statusIMKPEnum.BAST_WARRANTY_REVISION &&
                          item.status !== statusIMKPEnum.IMKP_DONE,
                      }"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="BAST"
                      @click="
                        item.status === statusIMKPEnum.IMKP_PUBLISHED ||
                        item.status === statusIMKPEnum.BAST_PROCESS ||
                        item.status === statusIMKPEnum.BAST_REVISION ||
                        item.status === statusIMKPEnum.BAST_WARRANTY ||
                        item.status === statusIMKPEnum.BAST_WARRANTY_REVISION ||
                        item.status === statusIMKPEnum.IMKP_DONE
                          ? clickBast(
                              item.id,
                              item.status,
                              item.judulProyek,
                              item.namaKontraktor,
                              'BAST',
                            )
                          : ''
                      "
                      style="text-decoration: none"
                    >
                      <img
                        src="../../assets/icons/file-contract.png"
                        alt=""
                        style="height: auto; width: 1.4rem"
                      />
                    </a>
                    <a
                      class="text-danger fw-bolder cursor-pointer"
                      :class="{
                        'opacity-50':
                          (item.status !== statusIMKPEnum.BAST_WARRANTY &&
                            item.status !==
                              statusIMKPEnum.BAST_WARRANTY_REVISION &&
                            item.status !== statusIMKPEnum.IMKP_DONE) ||
                          !item.isNeedBastWarranty,
                      }"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="BAST Garansi"
                      @click="
                        (item.status === statusIMKPEnum.BAST_WARRANTY ||
                          item.status ===
                            statusIMKPEnum.BAST_WARRANTY_REVISION ||
                          item.status === statusIMKPEnum.IMKP_DONE) &&
                        item.isNeedBastWarranty
                          ? clickBast(
                              item.id,
                              item.status,
                              item.judulProyek,
                              item.namaKontraktor,
                              'BAST Garansi',
                            )
                          : ''
                      "
                      style="text-decoration: none"
                    >
                      <img
                        src="../../assets/icons/file-contract-warranty.png"
                        alt=""
                        style="height: auto; width: 3.5rem; margin-top: 0.2rem"
                      />
                    </a>
                    <a
                      class="cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Amandemen"
                      :class="{
                        'opacity-50':
                          item.status !== statusIMKPEnum.IMKP_PUBLISHED,
                      }"
                      @click="
                        item.status === statusIMKPEnum.IMKP_PUBLISHED
                          ? clickAmandemen(item.id)
                          : ''
                      "
                    >
                      <img
                        src="../../assets/icons/file-amandemen.png"
                        alt=""
                        class="h-auto"
                        style="width: 1.4rem"
                      />
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" v-else>
        <p class="text-center font-medium text-lg text-slate-500">
          {{ cocMessage }}
        </p>
      </v-col>
    </v-row>
  </DefaultLayout>

  <CreateImkpModal
    v-model="dialogRequestImkp"
    title="Request Pengajuan IMKP"
    :locked-kontraktor="lockedKontraktor"
    @submit="submitRequestPengejuanIMKP"
  />
  <BastImkpModal
    v-model="dialogBast"
    :imkp-id="bastContext.id"
    :status="bastContext.status"
    :judul-proyek="bastContext.judulProyek"
    :nama-kontraktor="bastContext.namaKontraktor"
    :sio-id="sioID"
    @submitted="fetchData"
  />
  <BastWarrantyImkpModal
    v-model="dialogBastWarranty"
    :imkp-id="bastContext.id"
    :status="bastContext.status"
    :judul-proyek="bastContext.judulProyek"
    :nama-kontraktor="bastContext.namaKontraktor"
    @submitted="fetchData"
  />
  <AmandemenImkpModal
    v-model="dialogAmandemen"
    :imkp-id="amandemenId"
    @submitted="fetchData"
    @open-history="openHistory"
  />
  <HistoryAmandemenImkpModal v-model="dialogHistory" :imkp-id="historyId" />
  <div v-if="isLoading" class="loading-overlay" style="z-index: 3070">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import {
  API_BASE_URL,
  CMS_GET_IMKP_BY_KONTRAKTOR,
  CMS_SET_IMKP_OHS,
} from "@/constants";
import router from "@/router";
import { getSIOByIDContractor } from "@/utilities/globalFunction";
import axios from "axios";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import CreateImkpModal from "./components/CreateImkpModal.vue";
import BastImkpModal from "./components/BastImkpModal.vue";
import BastWarrantyImkpModal from "./components/BastWarrantyImkpModal.vue";
import AmandemenImkpModal from "./components/AmandemenImkpModal.vue";
import HistoryAmandemenImkpModal from "./components/HistoryAmandemenImkpModal.vue";
import { serializeSubLokasiForApi } from "./core/subLokasiHelpers";
import util from "@/assets/js/util";

const url_list = API_BASE_URL + CMS_GET_IMKP_BY_KONTRAKTOR;
const url_pengajuan_imkp = API_BASE_URL + CMS_SET_IMKP_OHS;

export default {
  mixins: [GlobalDataMixin],
  name: "ImkpPage",
  components: {
    DefaultLayout,
    CreateImkpModal,
    BastImkpModal,
    BastWarrantyImkpModal,
    AmandemenImkpModal,
    HistoryAmandemenImkpModal,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        {
          title: "Judul Proyek",
          key: "judulProyek",
          align: "start",
          sortable: true,
          width: "38%",
        },
        {
          title: "Tanggal Mulai",
          key: "tanggalDari",
          align: "center",
          sortable: true,
          width: "15%",
        },
        {
          title: "Tanggal Selesai",
          key: "tanggalSampai",
          align: "center",
          sortable: true,
          width: "15%",
        },
        {
          title: "Status",
          key: "status",
          align: "center",
          sortable: true,
          width: "13%",
        },
        { title: "Aksi", align: "center", sortable: false, width: "19%" },
      ]),
      isLoading: false,
      imkps: [],
      role: null,
      paramsImkp: {
        totalData: 0,
        totalPages: 0,
        currentPage: 1,
        perPage: 5,
        sortBy: null,
        sortDirection: null,
        keyword: "",
      },
      filtersInitialized: false,
      sioID: null,
      haveCoC: false,
      cocCheckPending: true,
      cocCheckSeq: 0,
      isBlockReqImkp: false,
      dialogRequestImkp: false,
      cocMessage: "",
      dialogBast: false,
      dialogBastWarranty: false,
      dialogAmandemen: false,
      dialogHistory: false,
      bastContext: {
        id: null,
        status: null,
        judulProyek: "",
        namaKontraktor: "",
      },
      amandemenId: null,
      historyId: null,
    };
  },
  computed: {
    lockedKontraktor() {
      return {
        id: this.userData.kontraktorID,
        namaKontraktor: this.userData.kontraktorName,
        idSio: this.sioID,
      };
    },
  },
  created() {
    this.initFiltersFromQuery();
    this.loadPage();
  },
  mounted() {
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      if (this.haveCoC) {
        this.fetchData();
      }
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.paramsImkp.keyword = q.keyword ?? "";
      if (q.page !== undefined && q.page !== "") {
        this.paramsImkp.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.paramsImkp.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        keyword: this.paramsImkp.keyword || undefined,
        page:
          this.paramsImkp.currentPage > 1
            ? this.paramsImkp.currentPage
            : undefined,
        perPage:
          this.paramsImkp.perPage !== 5 ? this.paramsImkp.perPage : undefined,
      };
      this.$router.replace({ query }).catch(() => {});
    },
    buildImkpQuery() {
      const q = {};
      if (this.paramsImkp.keyword) q.keyword = this.paramsImkp.keyword;
      if (this.paramsImkp.currentPage > 1)
        q.page = this.paramsImkp.currentPage;
      if (this.paramsImkp.perPage !== 5) q.perPage = this.paramsImkp.perPage;
      return q;
    },
    async loadPage() {
      await this.checkCoC();
    },
    refresh() {
      location.reload();
    },
    extractSioPayload(res) {
      if (!res) return null;

      const nested = res.data;
      if (nested && typeof nested === "object" && nested.id != null) {
        return nested;
      }

      if (res.id != null) return res;

      return null;
    },
    async checkCoC() {
      const seq = ++this.cocCheckSeq;
      this.cocCheckPending = true;

      const kontraktorId = this.userData?.kontraktorID ?? null;
      const isStale = () => seq !== this.cocCheckSeq;
      const finishLoading = () => {
        if (isStale()) return;
        this.isLoading = false;
        this.cocCheckPending = false;
      };

      if (!kontraktorId) {
        if (!isStale()) {
          this.haveCoC = false;
          this.sioID = null;
          this.cocMessage =
            "Data kontraktor tidak ditemukan. Silakan login ulang.";
        }
        finishLoading();
        return;
      }

      try {
        this.isLoading = true;

        let res = null;
        let sio = null;
        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          if (isStale()) return;

          res = await getSIOByIDContractor(kontraktorId);
          sio = this.extractSioPayload(res);

          if (sio?.id) break;

          if (attempt < maxAttempts) {
            await new Promise((resolve) => setTimeout(resolve, 400 * attempt));
          }
        }

        if (isStale()) return;

        this.haveCoC = Boolean(sio?.id);
        this.sioID = sio?.id ?? null;
        this.isBlockReqImkp = res?.isBlockReqImkp ?? false;

        if (this.haveCoC) {
          this.cocMessage = "";
          this.fetchData();
        } else {
          this.cocMessage =
            "Anda belum melakukan Pengajuan CoC. Silakan lakukan pengajuan CoC terlebih dahulu untuk dapat mengajukan IMKP";
        }
      } catch (error) {
        if (isStale()) return;

        this.haveCoC = false;
        this.sioID = null;

        this.cocMessage = "Gagal memuat data CoC. Silakan muat ulang halaman.";
      } finally {
        finishLoading();
      }
    },
    async submitRequestPengejuanIMKP(formData) {
      try {
        this.isLoading = true;
        const bodyJson = {
          sioId: this.sioID,
          kontraktorId: this.userData.kontraktorID,
          judulProyek: formData.judulProyek,
          lokasiKerja: formData.lokasiKerja.location_name,
          subLokasi: serializeSubLokasiForApi(formData.subLokasi),
          keteranganLokasiKerja: formData.keteranganLokasiKerja,
          usecase: levelEnum.KONTRAKTOR,
        };

        const result = await axios.post(url_pengajuan_imkp, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });

        console.log("result submitRequestPengejuanIMKP : ", result);

        if (result.data.status.StatusCode === 400) {
          util.showError(
            this.beautifyMessage(result.data.status.message),
            5000,
          );
        } else {
          util.showInfo("Kirim Pengajuan IMKP berhasil dibuat!", 2000);
          this.fetchData();
          this.dialogRequestImkp = false;
        }
      } catch (error) {
        console.log("ERR submitRequestPengejuanIMKP : ", error);
        util.showError("Terjadi kesalahan saat mengirim pengajuan IMKP.", 5000);
      } finally {
        this.isLoading = false;
      }
    },
    beautifyMessage(message) {
      if (typeof message !== "string") return message;
      return message.replace(/\[[^\][]*]/g, (match) => {
        try {
          const parsed = JSON.parse(match);
          if (Array.isArray(parsed)) {
            return parsed.map((item) => String(item).trim()).join(", ");
          }
        } catch {
          // bukan JSON array valid → biarkan apa adanya
        }
        return match;
      });
    },
    async fetchData({ page, itemsPerPage, sortBy } = {}) {
      try {
        if (page) {
          this.paramsImkp.currentPage = page;
        }
        if (itemsPerPage) {
          this.paramsImkp.perPage = itemsPerPage;
        }
        this.syncFiltersToUrl();

        this.isLoading = true;

        let params = {
          kontraktorId: this.userData.kontraktorID,
          page: this.paramsImkp.currentPage,
          perPage: this.paramsImkp.perPage,
          sortBy: sortBy ? sortBy[0]?.order : null,
          sortDirection: sortBy ? sortBy[0]?.key : null,
          judulProyek: this.paramsImkp.keyword?.trim(),
        };

        const res = await axios.get(url_list, {
          params: params,
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        });
        this.imkps = res.data.data;
        this.paramsImkp.totalData = res.data.header?.totalRows;
        this.paramsImkp.totalPages = res.data.header?.totalPages;

        let result = {};
        result.data = res.data.data;
        result.total_data = res.data.header?.totalRows;
        result.total_per_page = this.paramsImkp.perPage;
        result.current_page = this.paramsImkp.currentPage;
        this.dataTable = SetDataTableResponse(this.dataTable, result);
      } catch (error) {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    redirectToLink(link, id) {
      router.push({
        path: link + id,
        query: this.buildImkpQuery(),
      });
    },
    sortTable(field) {
      if (this.paramsImkp.sortBy == field) {
        if (this.paramsImkp.sortDirection == "asc") {
          this.paramsImkp.sortDirection = "desc";
        } else {
          this.paramsImkp.sortDirection = "asc";
        }
      } else {
        this.paramsImkp.sortDirection = "asc";
      }

      this.paramsImkp.sortBy = field;
      this.fetchData();
    },
    clickBast(id, status, judulProyek, namaKontraktor, type) {
      this.bastContext = { id, status, judulProyek, namaKontraktor };
      if (type === "BAST") {
        this.dialogBast = true;
      } else if (type === "BAST Garansi") {
        this.dialogBastWarranty = true;
      }
    },
    clickAmandemen(id) {
      this.amandemenId = id;
      this.dialogAmandemen = true;
    },
    openHistory(id) {
      this.historyId = id;
      this.dialogHistory = true;
    },
    normalizeList(text) {
      if (!text) return [];
      return text
        .split(/\r?\n/) // split by line break
        .filter(Boolean); // remove empty lines
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

:deep(thead) {
  background-color: #fecaca;
}
</style>
